import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["fieldDisabled", "sliderDoubleTheme", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FormControl, Slider } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

var propsSwitchCase = function propsSwitchCase(theme) {
  switch (theme) {
    case 'DoubleSteps':
      return {
        marks: true,
        step: 10,
        valueLabelDisplay: 'on',
        size: 'medium'
      };

    case 'Double':
      return {
        marks: false,
        step: undefined,
        valueLabelDisplay: 'off',
        size: 'medium'
      };
  }
};

var TAGSliderDoubleInput = function TAGSliderDoubleInput(_ref) {
  var fieldDisabled = _ref.fieldDisabled,
      sliderDoubleTheme = _ref.sliderDoubleTheme,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var railColors = {
    '.MuiSlider-track': {
      color: fieldDisabled ? 'neutrals.disabled' : 'secondary.main'
    },
    '.MuiSlider-thumb': {
      color: fieldDisabled ? 'neutrals.disabled' : 'secondary.main'
    },
    '.MuiSlider-valueLabelOpen': {
      background: 'neutrals.tertiary'
    },
    '.MuiSlider-rail': {
      color: 'neutrals.primary'
    },
    '.MuiSlider-markActive': {
      color: 'info.main'
    },
    '.MuiSlider-mark': {
      color: fieldDisabled ? 'neutrals.disabled' : 'backgrounds.white'
    }
  };
  var properties = propsSwitchCase(sliderDoubleTheme);
  return React.createElement(FormControl, {
    disabled: fieldDisabled,
    sx: sx
  }, React.createElement(Box, {
    width: 170
  }, React.createElement(Slider, _objectSpread(_objectSpread(_objectSpread({}, props), properties), {}, {
    sx: [railColors],
    disabled: fieldDisabled
  }))));
};

export default TAGSliderDoubleInput;